import { createContext, useState,useEffect } from "react";
import { firebaseFire, firebaseAuth} from './services/Firebase'
import { getDoc,getDocs,updateDoc,  query, where,doc,collection} from 'firebase/firestore'
import {signInWithEmailAndPassword,  signOut, sendPasswordResetEmail, onAuthStateChanged} from 'firebase/auth'
import { useAuthState } from "react-firebase-hooks/auth";
import {Maintenance} from './models/Maintenance';
import  secureLocalStorage  from  "react-secure-storage";
export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userLogin, setUser] = useState({});
    const [benefitId,setBenefitId] = useState('');
    const [benefit,setBenefit] = useState({});
    const [maintenance,setMaintenance] = useState(new Maintenance());
    const [user, error,loading] = useAuthState(firebaseAuth);
    const [activeModule,setActiveModule] = useState('');
    const USER_ROLE = 'partner';

    useEffect( () => {
        if(benefitId !=='') {
            findBenefit();
        }
    },[user,benefitId]);

    const login = (email, pass) => {
        let getError = null;
        signInWithEmailAndPassword(firebaseAuth,email, pass).then((userCredential) => {
            const customAttributes = JSON.parse(userCredential.user.reloadUserInfo.customAttributes);
            if(customAttributes
                && typeof customAttributes.roles !== 'undefined'
                && customAttributes.roles.includes(USER_ROLE)
            ){
                const docRef = doc(firebaseFire,"usuarios",email);
                getDoc(docRef).then((docSnap)=>{
                    if (docSnap.exists()) {
                        setUser(docSnap.data());
                        secureLocalStorage.setItem("user",JSON.stringify(docSnap.data()));
                    } else {
                        throw new Error("404");
                    }
                }).catch((error) => {
                    getError = error;
                    console.log(error);
                });
            }else{
                logout();
            }
        }).catch( (errors) => {
            getError = errors;
            logout();
        });
        return getError;
    }

    const sendPasswordReset = async (email) => {
        try {
          await sendPasswordResetEmail(firebaseAuth, email);
          alert("Password reset link sent!");
        } catch (err) {
          alert(err.message);
        }
      };

    const logout = () => {
        setBenefit({});
        setBenefitId('');
        signOut(firebaseAuth);
        secureLocalStorage.clear();
    };

    const findBenefit = () => {

        /*const docRef = doc(firebaseFire,"cobro_beneficios",benefitId);
        getDoc(docRef).then((docSnap)=>{
            if (docSnap.exists()) {
                setBenefit(docSnap.data());

            } else {
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log(error);
        });*/
    }

    const updateBenefit =  () => {
        const now = new Date();
        const docRef = doc(firebaseFire, "cobro_beneficios",benefitId);
        updateDoc(docRef, {
            estado: true,
            validado:{
                usuario: user.email,
                uid: user.uid,
                nombre: user.displayName,
                fecha: now.getTime(),
            }
        }).then( (e) => {
            benefit.estado = true;
            setBenefit({...benefit,validado:{
                usuario: user.email,
                uid: user.uid,
                nombre: user.displayName,
                fecha: now.getTime(),
             }});
        }).catch((error) => {
            console.log(error);
        });;


    }

    const findBenefitByCode =  (code) => {
        const q = query(collection(firebaseFire, "cobro_beneficios"),
                        where("codigo", "==", code),
                        where("estado", "==", false));
        getDocs(q).then( (docsSnap) => {
            if(docsSnap.docs.length > 0){
                setBenefit(docsSnap.docs[0].data());
                setBenefitId(docsSnap.docs[0].id);
            }else{
                setBenefit({});
            }

        }).catch((error) => {
            console.log(error);
        });
    }



    const partnerRegister  = (partner)  => {
        collection(firebaseFire,"partners").doc().set(partner)
        .then(() => {
            console.log("Partner registred");
        }).catch((err) => {
            throw err;
        });
    }

    const findUser = async (email) => {
        const docRef = doc(firebaseFire,"usuarios",email);
        return await getDoc(docRef).then((docSnap)=>{
            if (docSnap.exists()) {
                return docSnap.data();
            } else {
                throw new Error("404");
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const isLoggedIn = () =>{
        return onAuthStateChanged(firebaseAuth,(user) => {
            setUser(user);
            return user;
          });
    }

    const ContextProviderValues = {
        login,
        logout,
        findBenefit,
        setBenefitId,
        updateBenefit,
        findBenefitByCode,
        setBenefit,
        benefit,
        user,
        loading,
        error,
        sendPasswordReset,
        userLogin,
        maintenance,
        setMaintenance,
        partnerRegister,
        findUser,
        activeModule,
        setActiveModule,
        isLoggedIn
    };

    return (
        <UserContext.Provider value={ContextProviderValues}>
            {children}
        </UserContext.Provider>
    )
}
